import { z } from 'zod';
export const invitationSchema = z.object({
  email: z.string().min(1, 'El correo es obligatorio').email('Formato incorrecto'),
  roleToGrant: z.string().min(1, 'El rol es obligatorio'),
  force: z.boolean(),
});
